import React from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import Button from '@mui/material/Button';

// Components
import Typography from '../../../../../../components/Typography';

// Styles
import styles from './style.module.scss';
import viewsStyles from '../views.module.scss';

// Context
import { useDataSettingsContext } from '../../context';

// Types
import { View } from '../../types';

interface ViewSettingsProps {
  createPassword: boolean;
  onViewChange: (view: View) => void;
}

const ViewSettings: React.FC<ViewSettingsProps> = ({ createPassword, onViewChange }) => {
  const { t } = useTranslation();

  // Context
  const { user } = useDataSettingsContext();

  return (
    <div className={`${styles.container} overflow-hidden`}>
      <div className={viewsStyles.row}>
        <div className={viewsStyles.row_data}>
          <Typography variant="h3" className={viewsStyles.row_data_title}>
            {t('profile.settings.data.email')}
          </Typography>

          <Typography variant="span" className={`${styles.row_data_value} truncate md:w-full w-[200px]`}>
            {user?.email || t('profile.settings.data.email_missing')}
          </Typography>
        </div>

        <div className={viewsStyles.row_actions}>
          <Button
            variant='outlined'
            color='primary'
            className={`${viewsStyles.row_actions_button} dark:text-white dark:border-gray-400`}
            onClick={() => onViewChange('change_email')}
          >
            {t('profile.settings.data.change_email.title')}
          </Button>
        </div>
      </div>

      <div className={viewsStyles.row}>
        <div className={viewsStyles.row_data}>
          <Typography variant="h3" className={viewsStyles.row_data_title}>
            {t('profile.settings.data.password')}
          </Typography>

          <Typography variant="span" className={styles.row_data_value}>
            {t('profile.settings.data.change_password.sub_text')}
          </Typography>
        </div>

        <div className={viewsStyles.row_actions}>
          <Button
            variant='outlined'
            color='primary'
            className={`${viewsStyles.row_actions_button} dark:text-white dark:border-gray-400`}
            onClick={() => onViewChange('change_password')}
          >
            {t('profile.settings.data.change_password.title')}
          </Button>
        </div>
      </div>

      <Button
        variant='outlined'
        color='primary'
        className={`${styles.button} dark:text-white dark:border-gray-400`}
        onClick={() => onViewChange('manage')}
      >
        {t('profile.settings.data.account_management.title')}
      </Button>
    </div>
  );
};

export default ViewSettings;
